var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82143 4.34211V0.5H6.17857V4.34211V4.84211H6.67857H10.5V6.21053H6.67857H6.17857V6.71053V14.5H4.82143V6.71053V6.21053H4.32143H0.5V4.84211H4.32143H4.82143V4.34211Z",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC18);
export default __webpack_public_path__ + "static/media/c18.7e3b9ffc59abb0e380052264261ae0d2.svg";
export { ForwardRef as ReactComponent };